import { find } from 'lodash';

import { AgencyTypes } from '~/old-marketing/constants/AgencyTypes';

export const formatAgencyTypes = (types: string[]) => {
  if (!types.length) return;

  const formattedTypes = types.map((type) => find(AgencyTypes, ['value', type])?.name);

  if (formattedTypes.length > 1) {
    return [formattedTypes.slice(0, -1).join(', '), formattedTypes.slice(-1)[0]].join(' & ');
  }

  return formattedTypes.join(' & ');
};
